var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardVerificationValueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cvv_1_",
    "data-name": "cvv (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.147,
    height: 41.147,
    viewBox: "0 0 41.147 41.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11749",
    "data-name": "Path 11749",
    d: "M36.164,3.616A3.621,3.621,0,0,0,32.548,0H3.616A3.621,3.621,0,0,0,0,3.616V5.626H36.164Z",
    fill: "#df9426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11750",
    "data-name": "Path 11750",
    d: "M79.42,185H76.205a1.205,1.205,0,1,0,0,2.411H79.42a1.205,1.205,0,1,0,0-2.411Z",
    transform: "translate(-68.973 -170.133)",
    fill: "#df9426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11751",
    "data-name": "Path 11751",
    d: "M266.282,172.453a9.644,9.644,0,1,0-9.644,9.644A9.644,9.644,0,0,0,266.282,172.453Zm-10.464,2.968a.8.8,0,0,1-1.126-.158l-1.242-1.647-1.315,1.733a.8.8,0,0,1-1.28-.972l1.59-2.1-1.325-1.757a.8.8,0,1,1,1.283-.968l1.051,1.394,1.059-1.4a.8.8,0,0,1,1.28.972l-1.334,1.758,1.516,2.01A.8.8,0,0,1,255.819,175.421Zm6.449.083a.8.8,0,0,1-1.126-.154l-1.315-1.733-1.242,1.647a.8.8,0,1,1-1.283-.968l1.516-2.01-1.334-1.758a.8.8,0,1,1,1.28-.972l1.059,1.4,1.051-1.394a.8.8,0,0,1,1.283.968l-1.325,1.757,1.59,2.1A.8.8,0,0,1,262.268,175.5Z",
    transform: "translate(-227.145 -149.725)",
    fill: "#df9426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11752",
    "data-name": "Path 11752",
    d: "M29.493,102.637a11.985,11.985,0,0,1,6.671,2.019V100H0v11.653a3.621,3.621,0,0,0,3.616,3.616H17.453c-.009-.192-.014-.384-.014-.578A12.068,12.068,0,0,1,29.493,102.637Zm-19.046,9.016H7.233a3.616,3.616,0,1,1,0-7.233h3.215a3.616,3.616,0,1,1,0,7.233Z",
    transform: "translate(0 -91.964)",
    fill: "#df9426"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11753",
    "data-name": "Path 11753",
    d: "M422.015,400.8l-3.34-5.784a12.059,12.059,0,0,1-4.172,2.417l3.336,5.778a2.411,2.411,0,1,0,4.176-2.411Z",
    transform: "translate(-381.192 -363.273)",
    fill: "#df9426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVerificationValueIcon);
export default __webpack_public_path__ + "static/media/card_verification_value_icon.7fa974279c44dc78170cb91034976df7.svg";
export { ForwardRef as ReactComponent };